"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Link = function Link(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _react2["default"].createElement("path", {
    d: "M5.392 10.603c.151.15.357.235.571.233a.803.803 0 0 0 .571-.233l3.959-3.963A.81.81 0 0 0 9.35 5.497L5.392 9.459a.806.806 0 0 0-.005 1.139l.005.005zm9.542-9.552a3.61 3.61 0 0 0-5.093 0l-3.13 3.125A.81.81 0 0 0 7.854 5.32l3.121-3.125a2.027 2.027 0 0 1 2.816 0 1.99 1.99 0 0 1 .007 2.813l-.007.005-3.121 3.125a.806.806 0 0 0-.005 1.14l.005.004a.805.805 0 0 0 1.139.005c0-.002.002-.003.003-.005l3.122-3.133a3.607 3.607 0 0 0 .016-5.104c-.002-.001-.003-.003-.016.006zM8.031 10.78l-3.122 3.125a2.027 2.027 0 0 1-2.816 0 1.99 1.99 0 0 1-.006-2.813l.006-.006 3.122-3.125a.81.81 0 0 0-1.143-1.143L.95 9.95a3.611 3.611 0 0 0 .216 5.1 3.603 3.603 0 0 0 4.877 0l3.13-3.126a.81.81 0 0 0-1.142-1.144z",
    className: "fill"
  }));
};

exports["default"] = Link;